module.exports = __webpack_public_path__ + "media/icons/download-5934adb5.png";